export const WARM_AUDIO_ASSET_ID = "sfx-soft-bed";
export const OMINOUS_AUDIO_ASSET_ID = "sfx-alarm-sting";

/**
 * Honest rights label for DESK-authored fictional/procedural content.
 * Not CC0 and not a placeholder sample license.
 */
export const DESK_ORIGINAL_LICENSE = "DESK-Original" as const;

/**
 * Stable repo-local canonical URI for the café procedural asset provenance.
 * Points at the content module that declares these DESK-original assets.
 */
export const CAFE_WORLD_SOURCE_URI =
  "repo:desk/game/src/content/found-phone-pack.ts" as const;

export const CAFE_PROCEDURAL_SOURCE = {
  env: `${CAFE_WORLD_SOURCE_URI}#CafeInterior`,
  phone: `${CAFE_WORLD_SOURCE_URI}#PhoneProp`,
  counter: `${CAFE_WORLD_SOURCE_URI}#service-counter`,
} as const;

export const CAT_VISUAL_ASSETS = {
  kenneyCube: "vis-cat-kenney-cube",
  quaternius: "vis-cat-quaternius",
  kittyCorentin: "vis-cat-kitty-corentin",
} as const;
